// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookReview-module__clickable--E4oen {
  cursor: pointer;
}

.BookReview-module__spoiler--xOCTj {
  width: fit-content;
  display: inline-block;
  padding: 0 1px;
  background-image: linear-gradient(to bottom, transparent 45%, #f5dfa0 45%);
  border-radius:  3px;
  filter: blur(0.1px);
}`, "",{"version":3,"sources":["webpack://./src/pages/BookDetailPage/components/BookReviews/BookReview.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,0EAA0E;EAC1E,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".clickable {\n  cursor: pointer;\n}\n\n.spoiler {\n  width: fit-content;\n  display: inline-block;\n  padding: 0 1px;\n  background-image: linear-gradient(to bottom, transparent 45%, #f5dfa0 45%);\n  border-radius:  3px;\n  filter: blur(0.1px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clickable": `BookReview-module__clickable--E4oen`,
	"spoiler": `BookReview-module__spoiler--xOCTj`
};
export default ___CSS_LOADER_EXPORT___;
